import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import AssisterFilter from '../AssisterFilter';
import Table from '../Table';
import AlertMessage from '../../individualPortal/dashboard/AlertMsgs/AlertMessage';
import { ALL_USER_ROLES, USER_GROUPS } from '../../../constants/roles/userRoleTypes';
import { DELEGATION_HEADER_TYPES, labelNames, filterInputsMaxLength, filterInputsMaxLength_CA, DELEGATION_ALERT_MSGS, DELEGATION_FILTER_TITLE_TYPES, TRANSFER_DISPLAY_MSG_TYPE, TRANSFER_PAGE_TYPE } from '../../../constants/entity/entityTranferBOBConfig';


// Note paragraph available only for CSR group and Consumer.
const Note = ({ roleGroup }) => (
    (roleGroup === USER_GROUPS.CSR_GROUP || roleGroup === ALL_USER_ROLES.INDIVIDUAL) &&
    <div className="delegation__note">
        <p><FormattedMessage id="delegation_note_text"
            values={{ note: <b><FormattedMessage id="delegation_note"/></b> }}/></p>
    </div>
);

const InfoNote = ({ messageId }) => { 
    return (<div className="text-center">
        <span className="alert alert-info inline-block">                            
            <FontAwesomeIcon icon={faInfoCircle}/>
            <FormattedMessage id={messageId}/>
        </span>
    </div>);
};

const AssisterList = props => {
    
    const {
        isState,
        roleGroup,
        firstPageLoad,
        filters,        
        spinner,
        pagination,
        tableData,
        tableColumns,
        pageType,        
        onChangeHandler,
        onResetHandler,    
        onApplyHandler,
        pageNumber,
        onPageNumberChange        
    } = props;

    const handleKeyPress = (event) => {
        if(isState.ID && event.key === 'Enter'){
            onApplyHandler();
        }
    };

    const getPageText = (roleGroup) => {
        if(roleGroup === ALL_USER_ROLES.ASSISTERENROLLMENTENTITY){
            if(pageType === TRANSFER_PAGE_TYPE.CONSUMER){
                return (<AlertMessage
                    content={<FormattedMessage id={TRANSFER_DISPLAY_MSG_TYPE[roleGroup]}/>}
                    type="info"
                />);
            }else{
                const targetCecName = localStorage.getItem('targetCECName');
                const values = {
                    cecName : targetCecName
                };
                return (<AlertMessage
                    content={<FormattedMessage id='manage_cec_page_text_for_entityMgr' values={values}/>}
                    type="info"
                />);
            }
        }else{
            return (<AlertMessage
                content={<FormattedMessage id={TRANSFER_DISPLAY_MSG_TYPE[roleGroup]}/>}
                type="info"
            />);
        }
          
    };

    return (
        <Fragment>            
            <h1 className="delegation__header"><FormattedMessage id={DELEGATION_HEADER_TYPES[roleGroup]}/></h1>            
            {getPageText(roleGroup)}
            <h4 className="delegation__filter-header"><FormattedMessage id={DELEGATION_FILTER_TITLE_TYPES[roleGroup]}/></h4>
            <Note roleGroup={roleGroup}/>            
            {
                filters && Object.keys(filters).length > 0 &&
            <AssisterFilter
                filterList={filters}
                filterInputsMaxLength={isState.CA ? filterInputsMaxLength_CA : filterInputsMaxLength}                
                labelNames={labelNames}                
                formName='filterForm'
                handleChange={onChangeHandler}
                resetHandler={onResetHandler}
                applyHandler={onApplyHandler}
                handleKeyPress={handleKeyPress}
            />
            }           
            {
                firstPageLoad ? <Fragment>
                    <Table
                        data={tableData}
                        columns={tableColumns}
                    />                    
                    <InfoNote messageId={DELEGATION_ALERT_MSGS.ENTITYADMIN_PAGE_LOAD}/>
                </Fragment>
                    : spinner && spinner.activeSpinnersQty > 0 ? <FormattedMessage id='spinner.loading_data' tagName='div'/>
                        : <Fragment>
                            <Table
                                data={tableData}
                                columns={tableColumns}
                            />
                            {
                                !pagination.searchAPIInProgress && tableData && tableData.length == 0 ? <InfoNote messageId={DELEGATION_ALERT_MSGS.DEFAULT}/> : null
                            } 
                            
                        </Fragment>                            
                            
            }
            {
                pagination && pagination.count > 10 &&
            <ReactPaginate
                previousLabel={<FormattedMessage id="delegation_pagination_prev"/>}
                nextLabel={<FormattedMessage id="delegation_pagination_next"/>}
                breakLabel={'...'}
                breakClassName={'break-me'}
                previousClassName={'pagination_prev'}
                nextClassName={'pagination_next'}
                pageCount={Math.ceil(pagination.count / 10)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={onPageNumberChange}
                containerClassName={'pagination'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
                forcePage={pageNumber}
                hrefBuilder={() => {
                    return '#';
                }}
            />
            }
        </Fragment>
    );
};

export default AssisterList;